export var getCourseDetailStatisticDataSelector = function (state) { return state.courseDetailStatistic.data; };
